export default function(value) {
    return Intl.NumberFormat("en-GB", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1
    }).format(value);
}